import React, { useContext, useEffect, useState } from 'react'
import './singleuser.css'
import AdminNavbar from '../../admin-components/admin-nav/AdminNavbar'
import AdminBottomNav from '../../admin-components/adminbottomnav/AdminBottomNav'
import { useLocation } from 'react-router'
import axios from 'axios'
import { Context } from '../../context/Context';
import { useHistory } from 'react-router-dom'

function SingleUser() {
    const api_uri = "https://mentorxfa.herokuapp.com/api";   
    const location = useLocation()
    const {user} = useContext(Context);
    const path = location.pathname.split("/")[3];
    const [userr, setUserr] = useState({});

    const history = useHistory();

    useEffect(() => {
        const getUser = async () => {
            const res = await axios.get(api_uri+"/users/"+path);
            setUserr(res.data);                
        }
        getUser();   
    }, [path])

    const handleDelete = async () => {
        try {            
            await axios.delete(api_uri+`/users/${userr._id}`, {
                data: {role: user.role},
            });     
            setTimeout(() => {
                history.push("/admin/users")
            }, 250)  
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
        <AdminNavbar/>
        <div className="single-user">
            <div className="single-user-display">
                <h3 className="single-user-name"> {userr.username}</h3>    
                <i className="single-user-icon far fa-trash-alt" onClick={handleDelete} ></i> 
            </div>         
        </div>
        <AdminBottomNav/>
        </>
    )
}

export default SingleUser
